import styled from 'styled-components';

export const Container = styled.span`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
`;
